/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Quick_TitleInputs */

const vi_order_quick_title = /** @type {(inputs: Order_Quick_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đặt đơn nhanh`)
};

/**

* @param {Order_Quick_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_quick_title = /** @type {((inputs?: Order_Quick_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Quick_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_quick_title(inputs)
});